import React from 'react';
import { Component } from 'react';
import * as THREE from "three";
import { Scene, PerspectiveCamera, WebGLRenderer, AnimationMixer, AnimationClip, Object3D, Vector3 } from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import * as HelperFunctions from '../../common/helperFunctions';
import TWEEN from '@tweenjs/tween.js';
import * as Constants from '../../common/constants';
import Spinner from '../../common/components/spinner/spinner';

interface IProps {
    history?: any,
    lang: string
}

interface IState {
    isLoading: boolean;
    isUserInteracting: boolean;
}

class PanoramaImageComponent extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            isLoading: true,
            isUserInteracting: false
        }
    }

    container: any;
    scene: Scene = new Scene();
    camera: PerspectiveCamera = new PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 1100);
    renderer: WebGLRenderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    controls: any;
    loadingManager: any;
    onMouseDownMouseX = 0;
    onMouseDownMouseY = 0;
    lon = 0;
    onMouseDownLon = 0;
    lat = 0;
    onMouseDownLat = 0;
    phi = 0;
    theta = 0;

    animationFrame: any;
    interval: any;
    growl: any;
    boxSize: number = 0;
    mixer: AnimationMixer = new AnimationMixer(new Object3D());
    clock = new THREE.Clock();
    animations: Array<AnimationClip> = new Array<AnimationClip>(0);

    mouse: THREE.Vector2 = new THREE.Vector2();
    raycaster: THREE.Raycaster = new THREE.Raycaster();


    componentDidMount() {
        this.initScene();
        this.initObjects();
        this.animate();
        let canvas = document.getElementsByTagName('canvas')[0];
        canvas.addEventListener("resize", this.onWindowResize, false);
        canvas.addEventListener('mousedown', this.onPointerStart, false);
        canvas.addEventListener('mousemove', this.onPointerMove, false);
        canvas.addEventListener('mouseup', this.onPointerUp, false);

        canvas.addEventListener('touchstart', this.onPointerStart, false);
        canvas.addEventListener('touchmove', this.onPointerMove, false);
        canvas.addEventListener('touchend', this.onPointerUp, false);

    }

    componentWillUnmount() {
        cancelAnimationFrame(this.animationFrame);
        clearInterval(this.interval);
        //this.resourceTracker.dispose();
        this.onDestroy();
        let canvas = document.getElementsByTagName('canvas')[0];
        canvas.removeEventListener("resize", this.onWindowResize, false);
        canvas.removeEventListener('mousedown', this.onPointerStart, false);
        canvas.removeEventListener('mousemove', this.onPointerMove, false);
        canvas.removeEventListener('mouseup', this.onPointerUp, false);

        canvas.removeEventListener('touchstart', this.onPointerStart, false);
        canvas.removeEventListener('touchmove', this.onPointerMove, false);
        canvas.removeEventListener('touchend', this.onPointerUp, false);

    }

    initScene = () => {
        // Camera
        this.camera.position.x = 0; // -2000
        this.camera.position.y = 0; // 20000
        this.camera.position.z = 0; // 4000

        // Renderer    
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.renderer.autoClear = false;
        this.renderer.setClearColor(0x000000, 0.0);
        // this.renderer.shadowMap.enabled = true;
        // this.renderer.shadowMap.type = THREE.PCFShadowMap;
        this.container.appendChild(this.renderer.domElement);

        // Controls
        this.controls = new OrbitControls(this.camera, this.container);

    }

    initObjects = () => {
        let picurl: any = Constants.panoramaCenter;
        let param = HelperFunctions.getURLParameter("position");
        if (param)
            picurl = Constants[param];

        var geometry = new THREE.SphereBufferGeometry(500, 60, 40);
        geometry.scale(- 1, 1, 1);
        var texture = new THREE.TextureLoader().load(picurl);
        var material = new THREE.MeshBasicMaterial({ map: texture });
        let mesh = new THREE.Mesh(geometry, material);
        this.scene.add(mesh);
        setTimeout(() => {

            this.setState({ isLoading: false });
        });
    }

    animate = () => {
        if (this.mixer) {
            this.mixer.update(this.clock.getDelta());
        }
        this.animationFrame = requestAnimationFrame(this.animate);
        this.controls.update();
        TWEEN.update();

        if (this.state.isUserInteracting) {

            this.lon += 0.1;

        }

        this.lat = Math.max(- 85, Math.min(85, this.lat));
        this.phi = THREE.MathUtils.degToRad(90 - this.lat);
        this.theta = THREE.MathUtils.degToRad(this.lon);

        let target: Vector3 = new Vector3(500 * Math.sin(this.phi) * Math.cos(this.theta), 500 * Math.cos(this.phi), 500 * Math.sin(this.phi) * Math.sin(this.theta))

        this.camera.lookAt(target);

        this.renderer.render(this.scene, this.camera);
    }

    onPointerStart = (event) => {
        this.setState({ isUserInteracting: true });
        var clientX = event.clientX || event.touches[0].clientX;
        var clientY = event.clientY || event.touches[0].clientY;

        this.onMouseDownMouseX = clientX;
        this.onMouseDownMouseY = clientY;

        this.onMouseDownLon = this.lon;
        this.onMouseDownLat = this.lat;

    }

    onPointerMove = (event) => {
        if (this.state.isUserInteracting) {
            let touchX = event.touches && event.touches.length > 0 ? event.touches[0].clientX : 0;
            let touchY = event.touches && event.touches.length > 0 ? event.touches[0].clientY : 0;
            var clientX = event.clientX || touchX;
            var clientY = event.clientY || touchY;
            this.lon = (this.onMouseDownMouseX - clientX) * 0.1 + this.onMouseDownLon;
            this.lat = (clientY - this.onMouseDownMouseY) * 0.1 + this.onMouseDownLat;
        }
    }

    onPointerUp = () => {
        this.setState({ isUserInteracting: false });
    }

    onWindowResize = () => {
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
    }

    onNavigationCLick = (path: string) => {
        this.props.history.push(path);
    }

    onDestroy = () => {
        for (let anim of this.animations) {
            this.mixer.uncacheClip(anim);
        }
        HelperFunctions.disposeResource(this.scene);
        // if (this.scene) {
        //   this.scene.dispose();
        //   //@ts-ignore
        //   this.scene = undefined;
        // }

        // this.renderer.forceContextLoss();
        // this.renderer.renderLists.dispose();
        // this.renderer.dispose();
        // //@ts-ignore
        // this.renderer.domElement = undefined;
        // //@ts-ignore
        // this.renderer = undefined;
    }

    removeFromScene = (objectName: string, withLine: boolean) => {
        let objectInScene = this.scene.getObjectByName(objectName);
        if (objectInScene) {
            this.scene.remove(objectInScene);
        }
        if (withLine) {
            this.removeFromScene(objectName + 'Line', false);
            this.removeFromScene(objectName + 'GreenDot', false);
            this.removeFromScene(objectName + 'FirstDot', false);
            this.removeFromScene(objectName + 'SecondDot', false);
        }
    }

    render() {
        return (
            <>
                {this.state.isLoading ?
                    <Spinner /> : null}

                <div ref={ref => (this.container = ref)}></div>
            </>
        );
    }

}

export default PanoramaImageComponent;
